<template>
    <div class="row recent-orders submit-order-button">
        <div class="col-md-3 pb-3">
            <h3>Contact Form</h3>
            <div class="row">
                <div v-if="contactForm" class="col-md-12">
                    <!-- <form method="post" autocomplete="off" enctype="multipart/form-data" @submit.prevent="sendForm"> -->
                    <form
                        method="post"
                        autocomplete="off"
                        enctype="multipart/form-data"
                    >
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label class="text-muted">Your Name</label>
                                <input
                                    type="text"
                                    v-model="form.name"
                                    name="name"
                                    class="form-control"
                                    placeholder="Name"
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.name.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.name.$errors"
                                >
                                    {{ v$.form.name.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label class="text-muted">Your Email</label>
                                <input
                                    type="text"
                                    v-model="form.email_from"
                                    name="email"
                                    class="form-control"
                                    placeholder="Email"
                                    :class="{
                                        'is-invalid':
                                            submitted &&
                                            v$.form.email_from.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.email_from.$errors"
                                >
                                    {{
                                        v$.form.email_from.$errors[0]?.$message
                                    }}
                                </span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label class="text-muted">Subject</label>
                                <input
                                    type="text"
                                    v-model="form.subject"
                                    name="subject"
                                    class="form-control"
                                    placeholder="Subject"
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.subject.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.subject.$errors"
                                >
                                    {{ v$.form.subject.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label class="text-muted">Message</label>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    v-model="form.message"
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.message.$error,
                                    }"
                                ></textarea>
                                <span
                                    class="text-danger"
                                    v-if="v$.form.message.$errors"
                                >
                                    {{ v$.form.message.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <button
                                    type="button"
                                    class="btn btn-outline-danger text-uppercase float-end w-100"
                                    @click="handleSubmit"
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div v-else class="col-md-12">
                    <br />
                    <p>
                        Thanks for contacting us! We will be in touch with you
                        shortly.
                    </p>
                </div>
            </div>
        </div>

        <div class="col-md-3 pb-3">
            <h3>Contact</h3>
            <hr />
            <p class="mb-0">Your account representative is:</p>
            <div>
                <b
                    >{{ currentLocation.sales_rep?.first_name }}
                    {{ currentLocation.sales_rep?.last_name }}</b
                >
            </div>
            <div>
                <a
                    class="text-decoration-none"
                    href="tel:{{ currentLocation.sales_rep?.phone }}"
                    ><b>{{ currentLocation.sales_rep?.phone }}</b></a
                >
            </div>
            <div>
                <a
                    class="text-decoration-none"
                    href="mailto:{{ currentLocation.sales_rep?.email }}"
                    ><b>{{ currentLocation.sales_rep?.email }}</b></a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import TablePagination from "@/components/TablePagination.vue";
import SpeqOrders from "@/components/speq/orders/SpeqOrders.vue";

import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
} from "@vuelidate/validators";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        SpeqOrders,
    },
    setup() {
        const store = useStore();

        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        function sendEmail(form) {
            store.dispatch("sendEmail", form);
        }

        onMounted(() => {});

        return {
            currentLocation,
            sendEmail,
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            form: {
                name: "",
                email_from: "",
                email_to: this.currentLocation.sales_rep.email,
                name: "",
                subject: "",
                message: "",
            },
            contactForm: true,
            submitted: false,
        };
    },
    validations() {
        return {
            form: {
                name: { required },
                email_from: { required, email },
                name: { required },
                subject: { required },
                message: { required },
            },
        };
    },
    mounted() {},
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation
                this.sendForm();
            } else {
                // alert('Form failed validation')
            }
        },
        sendForm() {
            let formRequest = {
                location_id: this.currentLocation.id,
                email_from: this.form.email_from,
                email_to: this.form.email_to,
                name: this.form.name,
                subject: this.form.subject,
                message: this.form.message,
            };
            this.sendEmail(formRequest);
            this.contactForm = false;
        },
    },
};
</script>
